<div class="p-4">
  <form (ngSubmit)="onUserFormSubmit()">
    <!-- Allgemeine Einstellungen -->
    <div class="mb-4">
      <h5 class="mb-3 border-bottom pb-2">Allgemeine Einstellungen</h5>
      <p class="mb-2">Angemeldet als: <strong>{{ user?.full_name || 'Unbekannt' }}</strong></p>

      <!--      <div class="form-check mb-3">-->
      <!--        <input-->
      <!--          type="checkbox"-->
      <!--          class="form-check-input"-->
      <!--          id="newsletterCheck"-->
      <!--          [(ngModel)]="userForm.newsletter"-->
      <!--          name="newsletter"-->
      <!--        />-->
      <!--        <label class="form-check-label" for="newsletterCheck">-->
      <!--          An Newsletter teilnehmen-->
    <!--        </label>-->
  <!--      </div>-->

  <!--      <button type="submit" class="btn btn-primary">Einstellungen speichern</button>-->
</div>

@if (user?.is_patreon || user?.is_youtube_member) {
  <div class="mb-4">
    <h5 class="mb-3 border-bottom pb-2">Externe Verknüpfungen (Patreon, Youtube)</h5>
    <p class="text-muted">
      Es besteht eine aktive Verknüpfung mit
      @if (user.is_patreon) {
        <span>Patreon</span>
      }
      @if (user.is_patreon && user.is_youtube_member) {
        <span> und </span>
      }
      @if (user.is_youtube_member) {
        <span>YouTube</span>
        }.
      </p>
      <button type="button" class="btn btn-primary" (click)="unlinkAll()">
        Verknüpfung aufheben
      </button>
    </div>
  }
</form>
</div>
